<template>
  <div class="grid">
    <!-- {{$store.state.hotels.activehotel.segments}} -->
    <div class="grid segments">
      <div class="grid segmentlist">
        <button class="btn block dark sm" v-show="segment.name !== 'default'" @click="segmento = segment" v-for="(segment, index) in $store.state.hotels.activehotel.segments" :key="index">{{segment.name}}</button>
      </div>
      <div class="grid segmentsettings" v-if="segmento.name">
        <el-form key="form" ref="segmentform" :model="segmento" status-icon>
          <el-form-item label="nome segmento" >
            <el-input type="text" v-model="segmento.name" name="baseprice"></el-input>
          </el-form-item>
          <el-form-item label="colore segmento" >
            <el-color-picker v-model="segmento.color" @active-change="changecolor"></el-color-picker>
          </el-form-item>
        </el-form>
        <button class="btn block green sm" @click="$store.dispatch('hotels/updateSegments', segmento).then((data) => {$emit('close')})">Salva segmento</button>
        <div class="spacer xs"></div>
        <button class="btn block red sm" @click="$store.dispatch('hotels/deleteSegments', segmento).then((data) => {$emit('close')})">Cancella segmento</button>
      </div>
      <div class="grid seats" v-if="segmento.ombrelloni">
        <div class="grid seat" v-for ="(seat, index) in segmento.ombrelloni" :key="index">
          <div class="grid seat editseat selected" :style="{color: segmento.color, borderColor: segmento.color}">{{seat.ombrid}}</div>
          <unicon name="times-circle" fill="#333" @click="removeSeat(index, segmento)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import _ from 'lodash'
// import moment from 'moment'
// import helper from '../Mixins/helper'
export default {
  name: 'Editsegments',
  // mixins: [helper],
  props: {
    // hotel: Object
  },
  data () {
    return {
      changes: false,
      segmento: {}
    }
  },
  methods: {
    changecolor (color) {
      // console.log(color)
      this.segmento.color = color
    },
    removeSeat (index, segmento) {
      // console.log(index, segmento)
      segmento.ombrelloni.splice(index, 1);
    },
    show (section) {
      console.log(section)
      this.$emit('open', section)
    },
    save () {
      console.log('save')
      // this.$store.dispatch('hotels/updateHotel', this.hotel)
    }
  },
  filters: {

  },
  watch: {

  },
  computed: {

  },
  beforeMount () {

  },
  beforeDestroy () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fade-enter-active {
  transition: opacity .5s;
}
.fade-leave-active {
  transition: opacity 0s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all 0s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}
</style>
